/*Expanding contact*/
$(document).ready(function () {
    var wwExpandBlocks = $('.ww-expand-block');
    if (wwExpandBlocks.length > 0) {
        wwExpandBlocks.each(function (i) {
            var wwExpandBlock = wwExpandBlocks[i];

            $(wwExpandBlock).on('click', '.ww-expand-block__link', function (e) {
                e.preventDefault();
                $(this).toggleClass('ww-expand-block__link--active');
                $(this).next('.ww-expand-block__content').toggleClass('ww-expand-block__content--collapsed');
            });
        })
    }
})

